module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg6-93e71db98a6f9a939f7c89d15c66087c.jpg";